import { INotificationTreatment } from '@pushly/aqe/lib/interfaces/notification-treatment'
import randomstring from 'randomstring'
import { FeedNotificationPreviewDto } from '@halo/dtos/feed-notification-preview-dto'

export function extractSummaryNotification(notification: FeedNotificationPreviewDto): INotificationTreatment {
    const template = notification.defaultTemplate

    return {
        id: randomstring.generate(5),
        title: template.title || undefined,
        body: template.body || undefined,
        image: template.image_url || undefined,
        icon: template.icon_url || undefined,
        badge: template.badge_url || undefined,
        landingUrl: template.landing_url || undefined,
        landingUrlDisabled: !template.landing_url,
        actions: template.actions,
        keywords: notification.template.keywords,
    } as any
}
